if (!customElements.get('libero-purchase-shortcut')) {
  customElements.define('libero-purchase-shortcut', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
      this.abovePurchase = false;
      this.frame = null;
      this.scheduleUpdate = () => {
        if (this.frame !== null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateVisibility();
        });
      };
      this.resizeObserver = new ResizeObserver((entries) => {
        if (entries.some((entry) => entry.target === this.submit || entry.target === this.productInfo)) this.measurePurchase = true;
        this.scheduleUpdate();
      });
      this.resizeObserver.observe(this);
      window.addEventListener('resize', () => {
        this.measurePurchase = true;
        this.scheduleUpdate();
      }, options);
      window.addEventListener('load', this.scheduleUpdate, options);
      window.addEventListener('scroll', () => {
        if (!Number.isFinite(this.purchaseBottom)) return;
        const above = window.scrollY >= this.purchaseBottom;
        if (above === this.abovePurchase) return;
        this.abovePurchase = above;
        this.scheduleUpdate();
      }, { ...options, passive: true });
      document.addEventListener('product-info:loaded', () => this.bindPurchase(), options);
      this.querySelector('button')?.addEventListener('click', () => this.returnToPurchase(), options);
      this.bindPurchase();
    }

    bindPurchase() {
      this.productInfo = document.querySelector('product-info[id^="MainProduct-"]');
      const submit = this.productInfo?.querySelector('.product-form__submit');
      if (submit === this.submit && this.purchaseObserver) return;
      this.purchaseObserver?.disconnect();
      this.productObserver?.disconnect();
      if (this.submit) this.resizeObserver.unobserve(this.submit);
      if (this.observedProduct) this.resizeObserver.unobserve(this.observedProduct);
      this.submit = submit;
      this.abovePurchase = false;
      this.measurePurchase = true;
      if (submit) {
        this.resizeObserver.observe(submit);
        this.purchaseObserver = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this.submit);
          if (!entry) return;
          this.measurePurchase = true;
          this.scheduleUpdate();
        });
        this.purchaseObserver.observe(submit);
      }
      if (this.productInfo) {
        this.observedProduct = this.productInfo;
        this.resizeObserver.observe(this.productInfo);
        this.productObserver = new MutationObserver(() => {
          if (!this.submit?.isConnected) this.bindPurchase();
        });
        this.productObserver.observe(this.productInfo, { childList: true, subtree: true });
      }
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.purchaseObserver?.disconnect();
      this.productObserver?.disconnect();
      this.previewObserver?.disconnect();
      this.purchaseObserver = null;
      this.previewObserver = null;
      this.submit = null;
      this.preview = null;
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
      document.documentElement.style.removeProperty('--libero-purchase-reserve');
    }

    headerBottom() {
      return Math.max(0, document.querySelector('.libero-header')?.getBoundingClientRect().bottom || 0);
    }

    updateVisibility() {
      if (this.measurePurchase && this.submit?.isConnected) {
        const rect = this.submit.getBoundingClientRect();
        this.abovePurchase = rect.width > 0 && rect.bottom <= 0;
        this.purchaseBottom = rect.width > 0 ? rect.bottom + window.scrollY : null;
        this.measurePurchase = false;
      }
      const enabled = this.dataset[this.mobileQuery.matches ? 'mobile' : 'desktop'] !== 'false';
      const visible = enabled && this.abovePurchase && Boolean(this.submit?.isConnected);
      const preview = document.getElementById('PBarNextFrameWrapper');
      if (preview !== this.preview) {
        if (this.preview) this.resizeObserver.unobserve(this.preview);
        this.previewObserver?.disconnect();
        this.preview = preview;
        if (preview) {
          this.resizeObserver.observe(preview);
          this.previewObserver = new IntersectionObserver(this.scheduleUpdate, { threshold: [0, 1] });
          this.previewObserver.observe(preview);
        }
      }
      const previewRect = preview?.getBoundingClientRect();
      const offset = previewRect && previewRect.bottom > 0 && previewRect.top < window.innerHeight
        ? Math.max(0, window.innerHeight - Math.max(0, previewRect.top)) : 0;
      const height = visible && !this.hidden ? this.getBoundingClientRect().height : 0;
      if (this.hidden === visible) this.hidden = !visible;
      const offsetValue = `${offset}px`;
      if (this.style.getPropertyValue('--libero-preview-offset') !== offsetValue) {
        this.style.setProperty('--libero-preview-offset', offsetValue);
      }
      const reserve = document.documentElement.style;
      if (height > 0 && reserve.getPropertyValue('--libero-purchase-reserve') !== `${height}px`) {
        reserve.setProperty('--libero-purchase-reserve', `${height}px`);
      }
    }

    returnToPurchase() {
      const picker = this.productInfo?.querySelector('variant-selects');
      const target = picker?.querySelector('fieldset, select') || picker || this.submit;
      if (!target) return;
      const focusTarget = target.matches('select, button') ? target : target.querySelector('input:checked:not(:disabled), select:not(:disabled), input:not(:disabled)');
      const top = target.getBoundingClientRect().top + window.scrollY - this.headerBottom() - 24;
      focusTarget?.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}
